import { render, staticRenderFns } from "./ContentBlockEdit.vue?vue&type=template&id=3c587c83&"
import script from "./ContentBlockEdit.vue?vue&type=script&lang=js&"
export * from "./ContentBlockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports